<template>
  <div class="reservaYes">
    <Headers></Headers>
    <div class="centerYse">
      <img src="https://aliyunosszs.musicwow.com/APPimg/league/reservation1.jpg"> 
      <P>预约加盟成功，</P>
      <P>工作人员将在3个工作日内</P>
      <P class="centerYse-tel">通过电话联系您！</P>
      <div class="blackHome" @click="handBlackBut(1)">返回首页 ></div>
    </div>  
    
    
    <Footer></Footer>
  </div>
</template>
<script>
import Headers from '@/components/header.vue'
import Footer from '@/components/footer.vue'
export default {
  components: {
    Headers,
    Footer,
  },
  name: 'reservaYes',
  data() {
    return{

    } 
  },
  methods: {
    handBlackBut(type){
      
      sessionStorage.typeHide = type
      this.$router.push({name:'Home',params:{ type:type}});
    }

  },
  mounted () {

  }

}

</script>
<style lang="sass" scoped>
.reservaYes   
  .centerYse
    padding: 160px 0 
    img
      width: 96px !important
      height: 96px !important
      margin-bottom: 32px
    P
      font-size: 18px
      color: rgba(0,0,0,0.5)
      line-height: 30px
    .centerYse-tel
      margin-bottom: 34px  
    .blackHome
      width: 222px
      height: 39px
      background: #07D1AA
      border-radius: 30px
      color: #fff
      font-size: 18px
      line-height: 39px
      margin: auto 















</style>

